export class TenantAlreadyExistsError {
    tenantAlreadyExists = true;
}
